import AppConstants from "../config/app.constants";

let BillingCategoryService = function ($http, $q) {

    let all = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/billing-category`, {
                params: {
                    search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };


    let create = (data) => {
        return $http
            .post(AppConstants.api + `/billing-category/create-billing-category`, data)
            .then((res) => {
                return res.data
            })
    }

    let update = (id, data) => {
        return $http
            .post(AppConstants.api + `/billing-category/${id}/update`, data)
            .then((res) => {
                return res.data
            })
    }

    let get = (id) => {
        return $http
            .get(AppConstants.api + `/billing-category/${id}/details`)
            .then((res) => {
                return res.data
            })
    }

    return {
        create,
        all,
        update,
        get
    }
}

BillingCategoryService.$inject = ['$http', '$q']

export default BillingCategoryService;


// WEBPACK FOOTER //
// ./client/app/services/billing-category.service.js